import { ARS_ROUTES } from '@/modules/ars/routes/config';
import { BIA_ROUTES } from '@/modules/bia/routes/config';
import { ERZ_ROUTES } from '@/modules/erz/routes/config';
import { IAC_ROUTES } from '@/modules/iac/routes/config';
import { PAY_ROUTES } from '@/modules/pay/routes/config';
import { RMP_ROUTES } from '@/modules/rmp/routes/config';
import { WNT_ROUTES } from '@/modules/wnt/routes/config';

import { GENERAL_ROUTES } from './config';

export type SeoData = {
  description?: string;
  keywords?: string[];
  canonical?: string;
};

export type AllRouteKeys =
  | keyof typeof GENERAL_ROUTES
  | keyof typeof ARS_ROUTES
  | keyof typeof BIA_ROUTES
  | keyof typeof ERZ_ROUTES
  | keyof typeof IAC_ROUTES
  | keyof typeof PAY_ROUTES
  | keyof typeof RMP_ROUTES
  | keyof typeof WNT_ROUTES;

export const seoConfig: Partial<Record<AllRouteKeys, SeoData>> = {
  HOME: {
    description: 'Головна сторінка - швидкий доступ к заявкам та послугам',
    keywords: [
      'Єдине вікно',
      'Єдине вікно для громадян',
      'Єдине вікно МВС',
      'cabinet.mvs.gov.ua',
      'страхування власників зброї',
      'витяг з Єдиного реєстру зброї',
      'державні послуги, довідки',
    ],
  },

  NEWS: {
    description: 'Всі новини нашого сервісу',
    keywords: ['новини', 'оновлення послуг'],
  },

  INTERNAL_SERVICES: {
    description: 'Послуги',
    keywords: [
      'придбання зброї',
      'страхування власників зброї',
      'перевірка витягу з Єдиного реєстру зброї',
      'направлення на комісійний продаж зброї',
      'продовження дозволу на придбання та зберігання зброї',
    ],
  },

  PERSONAL_DATA: {
    description:
      'Повідомлення про обробку персональних даних сервісом центральної підсистеми єдиної інформаційної системи Міністерства внутрішніх справ Єдине вікно',
    keywords: ['Політика конфіденційності'],
  },

  USER_PROFILE: {
    description: 'Профіль користувача',
    keywords: ['Профіль користувача'],
  },

  EXTERNAL_SERVICES: {
    description: 'Інші державні послуги',
    keywords: [
      'кабінет пацієнта медичної інформаційної системи МВС',
      'пошук паспорта громадянина, зброя у розшуку, кабінет водія',
    ],
  },

  CRIMINAL_RECORD_SEARCH: {
    description: 'Перевірка витягу про наявність судимості',
    keywords: ['витяг про судимість', 'перевірка'],
  },

  SEARCH_INCOMING_CORRESPONDENCE: {
    description: 'Пошук вхідної кореспонденції',
    keywords: ['кореспонденція', 'пошук'],
  },

  INSURANCE_ORDERS: {
    description: 'Замовлення поліса страхування відповідальності власників зброї',
    keywords: ['страхування', 'поліс', 'замовлення'],
  },

  ERZ_SEARCH: {
    description: 'Перевірка витягу з Єдиного реєстру зброї',
    keywords: ['витяг', 'перевірка'],
  },

  PAYMENT_WITHOUT_APPLICATION: {
    description: 'Оплата послуг. Єдине вікно',
    keywords: ['послуги', 'оплата'],
  },

  MISSING_PASSPORT: {
    description: 'Пошук паспорта громадянина України серед викрадених та втрачених',
    keywords: ['втрачений паспорт', 'пошук'],
  },

  MISSING_PHONE: {
    description: 'Мобільні телефони у розшуку. Перевірка за IMEI',
    keywords: ['мобільний телефон', 'розшук', 'IMEI'],
  },

  WANTED_WEAPON: {
    description: 'Пошук за серією та номером зброї',
    keywords: ['зброя', 'розшук'],
  },

  WANTED_ART: {
    description: 'Культурні цінності у розшуку',
    keywords: ['розшук', 'культурні цінності'],
  },

  MISSING_INCAPACITATED_PERSONS: {
    description: 'Пошук осіб, що не можуть надати про себе відомостей внаслідок хвороби або неповнолітнього віку',
    keywords: ['пошук осіб'],
  },

  MISSING_CORPSES: {
    description: 'Пошук невстановлених померлих осіб',
    keywords: ['послуги', 'померлі'],
  },

  WANTED_PERSON_SEARCH: {
    description: 'Особи, які переховуються від органів влади',
    keywords: ['розшук осіб'],
  },

  MISSING_PERSON_SEARCH: {
    description: 'Пошук зниклих громадян',
    keywords: ['пошук', 'зниклі'],
  },

  MISSING_CHILDREN_SEARCH: {
    description: 'Зниклі діти',
    keywords: ['зниклі діти', 'пошук'],
  },

  VEHICLE_SEARCH: {
    description: 'Транспортні засоби у розшуку',
    keywords: ['розшук', 'транспортні засоби'],
  },

  CHECK_EXTRACT_VERIFICATION: {
    description: 'Перевірка витягу з Єдиного реєстру осіб, зниклих безвісти за особливих обставин',
    keywords: ['витяг з Єдиного реєстру осіб', 'зниклих безвісти, перевірка'],
  },
};
